import { z } from 'zod';
import { paginationFiltersSchema } from 'utils/schemas';

export const recognitionAllowancesFiltersSchema = z
  .object({})
  .merge(paginationFiltersSchema);

export const recognitionAllowanceDetailsFiltersSchema = z
  .object({})
  .merge(paginationFiltersSchema);
